import Masonry from "masonry-layout";

export default function loadListConfig(){
  const list = document.querySelector('.list-masonry');
  if(list) {
    const msr = new Masonry(list, {
      itemSelector: '.item-grid',
      columnWidth: function (containerWidth) {
        return containerWidth / 2;
      }.call(),
      isAnimated: false
    });
  }
}
